import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLimit } from "../RTK/Features/filter/filterSlice";
import { fetchTransactions } from "../RTK/Features/Transaction/TrnasactionSlice";
import Transaction from "./Transaction";
import { useMatch } from "react-router-dom";
function AllTransactionBody() {
  const dispatch = useDispatch();
  const { noOfTotalRecords, transactions, loading, error, isError } =
    useSelector((state) => state.transaction);
  let { searchTerm, transactionType, order, limit } = useSelector(
    (state) => state.filter
  );

  React.useEffect(() => {
    limit = limit === 0 ? 10 : limit;
    dispatch(
      fetchTransactions({
        searchTerm,
        transactionType,
        order,
        limit,
        balanceRequired: false,
      })
    );
  }, [dispatch, limit, order, transactionType, searchTerm, noOfTotalRecords]);

  return (
    <div className="w-full flex gap-4 items-center justify-center flex-wrap	 pt-24 pb-4 px-16">
      {transactions.map((transaction) => (
        <Transaction
          key={transaction.id}
          transaction={transaction}
          allTransactions
        />
      ))}
    </div>
  );
}

export default AllTransactionBody;
